import React, { Component } from 'react';

class Offer extends Component {

    render() {
        // Dados dos perfis para facilitar a edição
        const perfis = [
            {
                icon: "fa-clock-o",
                title: "Sem tempo a perder",
                text: "Quem quer viajar sem perder tempo pesquisando tudo sozinho."
            },
            {
                icon: "fa-users",
                title: "Famílias",
                text: "Famílias que buscam uma viagem tranquila e sem imprevistos."
            },
            {
                icon: "fa-heart",
                title: "Casais e Lua de Mel",
                text: "Casais que sonham com uma viagem perfeita e romântica."
            },
            {
                icon: "fa-shield",
                title: "Segurança Total",
                text: "Viajantes que valorizam segurança, suporte e orientação em cada etapa."
            },
            {
                icon: "fa-money",
                title: "Economia Inteligente",
                text: "Quem quer economizar escolhendo o melhor custo-benefício."
            }
        ];

        return (
            <div className="offer-area pd-top-100 pd-bottom-70" style={{ background: '#f9f9f9' }}>
                
                {/* CSS Específico para este componente (Cards Modernos) */}
                <style>{`
                    .target-card {
                        background: #fff;
                        padding: 35px 25px;
                        border-radius: 15px;
                        box-shadow: 0 5px 20px rgba(0,0,0,0.05);
                        transition: all 0.3s ease;
                        height: 100%;
                        border-bottom: 3px solid transparent;
                        position: relative;
                        overflow: hidden;
                    }
                    .target-card:hover {
                        transform: translateY(-10px);
                        box-shadow: 0 15px 30px rgba(0,0,0,0.1);
                        border-bottom: 3px solid #D1AD69;
                    }
                    .target-icon-box {
                        width: 70px;
                        height: 70px;
                        line-height: 70px;
                        background: rgba(209, 173, 105, 0.1);
                        border-radius: 50%;
                        text-align: center;
                        margin: 0 auto 25px;
                        color: #D1AD69;
                        font-size: 30px;
                        transition: all 0.3s ease;
                    }
                    .target-card:hover .target-icon-box {
                        background: #D1AD69;
                        color: #fff;
                    }
                    .target-title {
                        font-weight: 700;
                        margin-bottom: 15px;
                        font-size: 1.25rem;
                    }
                    .target-text {
                        color: #666;
                        font-size: 0.95rem;
                        line-height: 1.6;
                        margin-bottom: 0;
                    }
                `}</style>

                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-8 col-lg-10">
                            <div className="section-title text-center mb-5">
                                <h2 className="title">Para quem é a Flutuar?</h2>
                                <p style={{ maxWidth: '600px', margin: '0 auto' }}>
                                    Se você se encaixa em algum desses perfis, nós somos a agência ideal para você:
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        {perfis.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
                                <div className="target-card text-center">
                                    <div className="target-icon-box">
                                        <i className={`fa ${item.icon}`}></i>
                                    </div>
                                    <h4 className="target-title">{item.title}</h4>
                                    <p className="target-text">{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default Offer;